import { Helmet } from 'react-helmet-async'

type SocialShareMetaProps = {
    title: string
    description: string
    imageUrl: string
    url: string
    type?: 'website' | 'article'
}

/**
 * Own Helmet tree (not nested under PageHelmet): react-helmet-async + React 19
 * drops Fragment children, so share tags cannot be wrapped in a fragment helper.
 */
export function SocialShareMeta({ title, description, imageUrl, url, type = 'website' }: SocialShareMetaProps) {
    return (
        <Helmet>
            <meta property='og:type' content={type} />
            <meta property='og:title' content={title} />
            <meta property='og:description' content={description} />
            <meta property='og:image' content={imageUrl} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:url' content={url} />
            <meta name='twitter:title' content={title} />
            <meta name='twitter:description' content={description} />
            <meta name='twitter:image' content={imageUrl} />
        </Helmet>
    )
}
